module.exports = __webpack_public_path__ + "media/images/advert-img-06-01c59c09b524d343030f78bfdb7b26f2.png";